module.exports = __webpack_public_path__ + "static/media/icono (7).2231ba48.svg";